import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { BasicButton } from '../../../../../assets/common';
import { finder_filter_disable, finder_filter_enable } from '../../../../../assets/img';
import { ModelTC } from '../../../../../components';
import { CommonFilterManaging } from '../../../../../components/CommonFilterManaging';
import { adminApi } from '../../../../../services/admin';
import { resetCriteriaState } from '../../redux/manageCriteriaSetMatchingSlice';
import styles from './menu-bar-criteria-cp.module.scss';

export default function MenuBarManagingCriteriaCP(props) {
  const {
    showFilter,
    setShowFilter,
    positionLabelSelected,
    setPositionLabelSelected,
    businessSelected,
    setBusinessSelected,
    setKeyword,
    updateStatusVisible,
    setUpdateStatusVisible,
    deleteSelecteds,
    handleDeleteRecord,
    loading,
    keyword,
    fetchData,
  } = props;

  const [businessOptions, setBusinessOptions] = useState([]);
  const [positionLabelOptions, setPositionLabelOptions] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();

  const handleAddNew = () => {
    dispatch(resetCriteriaState());
    history.push(`/admin/sp-management/managing-criteria-for-critical-position/add`);
  };

  const fetchFilterOptions = async () => {
    try {
      const res = await adminApi.getApprovedSPFilter();
      if (res.status === 200) {
        setBusinessOptions(res.data.result.business);
        setPositionLabelOptions(res.data.result.position_labels);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  return (
    <div>
      <Row align="bottom" justify="space-between">
        <ModelTC
          info={{
            type: 'deleteMultiManagingCriteriaCP',
            visible: updateStatusVisible,
            setVisible: setUpdateStatusVisible,
            handleSubmit: () => handleDeleteRecord(),
            loading,
            onClose: () => {
              setUpdateStatusVisible(false);
            },
          }}
        />
        <Col span={16}>
          <Row align="bottom" gutter={8}>
            <Col span={18}>
              <input
                data-testid="search-input"
                placeholder="Search Position Code or Position Name"
                className={styles.searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                value={searchInput}
              />
            </Col>
            <Col>
              <BasicButton
                mode="teal"
                onKeyDown={() => {}}
                onClick={() => {
                  keyword === searchInput ? fetchData() : setKeyword(searchInput);
                }}
              >
                Search
              </BasicButton>
            </Col>
          </Row>
        </Col>

        <Col>
          <Row align="bottom" justify="space-between" gutter={8}>
            <Col>
              <BasicButton
                onKeyDown={() => {}}
                onClick={() => deleteSelecteds.length > 0 && setUpdateStatusVisible(true)}
                className={`${styles.button} ${
                  !deleteSelecteds.length ? styles.inActiveDelBtn : styles.activeDelBtn
                }`}
                disabled={!deleteSelecteds.length}
              >
                Confirm Delete Position
              </BasicButton>
            </Col>
            <Col>
              <BasicButton mode="teal" onKeyDown={() => {}} onClick={handleAddNew}>
                Add New
              </BasicButton>
            </Col>
            <Col>
              <div className={styles.icons}>
                <img
                  src={showFilter ? finder_filter_enable : finder_filter_disable}
                  alt="Filter"
                  onKeyDown={() => {}}
                  onClick={() => {
                    setShowFilter(!showFilter);
                  }}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      {showFilter && (
        <Row style={{ marginTop: 22 }}>
          <Col>
            <Row gutter={16}>
              <Col>
                <CommonFilterManaging
                  setIsSearch={() => {}}
                  selectedOptions={positionLabelSelected}
                  setSelectedOptions={setPositionLabelSelected}
                  allOptions={[
                    {
                      label: '(Select All)',
                      value: 'all',
                    },
                    ...positionLabelOptions,
                  ]}
                  placeholder="Position Label"
                />
              </Col>
              <Col>
                <CommonFilterManaging
                  setIsSearch={() => {}}
                  selectedOptions={businessSelected}
                  setSelectedOptions={setBusinessSelected}
                  allOptions={[
                    {
                      label: '(Select All)',
                      value: 'all',
                    },
                    ...businessOptions,
                  ]}
                  placeholder="Business"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </div>
  );
}
